/* Ott-common */
import { normalize } from '@dtvgo/typed-normalizr';
import { AuthType } from '@dtvgo/axios-interceptor-auth';

/* Utils */
import {
  SectionEntity, SectionId, VodContentEntity, ShowEntity,
} from '../../utils';

/**
 * @param {import('axios').AxiosInstance} backendAxiosInstance
 */
export default function thinkAnalytics(backendAxiosInstance) {
  /**
   * @param {string} showId
   */
  async function getContinueWatchingShowPdp(showId) {
    const response = await backendAxiosInstance.get(`/experience/v1/ThinkAnalytics/usecase/continuewatching/show/${showId}`, {
      includeTimeZone: true,
      includeEntitlements: true,
      authType: AuthType.SESSION_TOKEN,
    });

    const continueWatchingEpisode = response.data.section?.items[0];
    response.normalizedData = continueWatchingEpisode && normalize(
      continueWatchingEpisode, VodContentEntity,
    );
    return response;
  }

  /**
   * @param {string} contentId
   */
  async function getContinueWatchingMovie(contentId) {
    const response = await backendAxiosInstance.get(`/experience/v1/ThinkAnalytics/usecase/continuewatching/movie/${contentId}`, {
      includeTimeZone: true,
      includeEntitlements: true,
      authType: AuthType.SESSION_TOKEN,
    });

    const continueWatchingContent = response.data.section?.items[0];
    response.normalizedData = continueWatchingContent && normalize(
      continueWatchingContent, VodContentEntity,
    );

    return response;
  }

  /**
   * @typedef GetMoreLikeThisParams
   * @type {object}
   * @property {string} contentId
   * @property {import('../../utils/normalizr/constants').ContentSourceType} contentSourceType
   * @property {string} showId
   */

  /**
   * @param {GetMoreLikeThisParams} getMoreLikeThisParams
   */
  async function getMoreLikeThis({ contentId, contentSourceType, showId }) {
    const response = await backendAxiosInstance.get(`${'/experience/v1/ThinkAnalytics/usecase/morelikethis?'
      + 'id='}${contentId}&contentSourceId=${contentSourceType}`, {
      includeTimeZone: true,
      includeEntitlements: true,
      authType: AuthType.SESSION_TOKEN,
    });

    response.normalizedData = normalize({
      moreLikeThis: response.data.section.items,
      id: showId || contentId,
    }, showId ? ShowEntity : VodContentEntity);

    return response;
  }

  async function getMostwatchedChannels() {
    const response = await backendAxiosInstance.get('/experience/v1/ThinkAnalytics/usecase/mostwatchedchannels',
      {
        includeTimeZone: true,
        authType: AuthType.SESSION_TOKEN,
      });

    response.normalizedData = normalize({
      ...response.data.section,
      id: SectionId.MOST_WATCHED,
      isTAMostWatched: true,
    }, SectionEntity);

    return response;
  }

  return {
    getContinueWatchingShowPdp,
    getContinueWatchingMovie,
    getMoreLikeThis,
    getMostwatchedChannels,
  };
}
